
export default function summary( state = { 'OUTPUT' : { 'DATA' : [1] } }, action = {} ){

    switch( action.type ){
        case 'GET_SUMMARY_ANNUAL_LEAVE':
            return action.summary
        case 'GET_REQUEST_SUMMARY':
            return action.summary
        default: return [];
    }

}



// WEBPACK FOOTER //
// ./src/store/reducers/summary/summary.reducer.js